module.exports = __webpack_public_path__ + "static/screenshot-eadddba852a345747e93000a39a8f3b7.jpg";